module.exports = __webpack_public_path__ + "img/vipevent_useshare_icon@2x.2ab52d29.png";